import styled from 'styled-components';
import media from 'src/styles/Media.styled';
export const SubTitleComponent = styled.p`
    font-family: 'AvenirNextWorld Demi';
    font-size: 20px;
    align-content: 'left';
    color: #140f4b;
    ${media.mobileDevice`
        background-color: 'red';
    `};
`;

export const ReviewContainer = styled.div`
    display: inline-flex;
    width: 100%;

    ${media.mobileDevice`
        flex-direction:column;
        justify-content: space-between;
        margin: 0px;
    `}
`;
export const SignatureTitle = styled.span`
    font-weight: bold;
    line-height: 28px;
    display: flex;
    font-size: 10px;
`;

export const ContractTitle = styled.p`
    font-weight: bold;
    line-height: 28px;
    display: flex;
    font-size: 10px;
    color: #202124;
`;

export const Type = styled.span`
    background: #ebebeb 0% 0% no-repeat padding-box;
    border-radius: 10px;
    display: inline;
    padding-left: 5px;
    padding-right: 5px;
    margin-left: 5px;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: -0.1px;
    color: #140f4b;
    opacity: 1;
    font-size: 13px;
`;

export const Data = styled.div`
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Demi'};
    color: ${({ color }) => (color ? color : '#140F4B')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '15px')};
    ${media.mobileDevice`
    margin: ${({ margin }) => (margin ? margin : '')};
    `}
`;

export const StyledDiv = styled.div`
    width: ${({ desktopWidth }) => (desktopWidth ? desktopWidth : '100%')};
    display: ${({ desktopDisplay }) => (desktopDisplay ? desktopDisplay : '')};
    justify-content: ${({ desktopJustifyContent }) =>
        desktopJustifyContent ? desktopJustifyContent : ''};
    ${media.mobileDevice`
           width:  ${({ width }) => (width ? width : '62%')};
           display: ${({ display }) => (display ? display : '')} ;
           justify-content: ${({ justifyContent }) =>
               justifyContent ? justifyContent : ''} ;
           
    `}
`;

export const DataContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 50%;
    ${media.mobileDevice`
        width: 70%;
        margin-bottom: 10px;
    `}
`;

export const QuantityContainer = styled.div`
    display: flex;  
    width: 20%;
    ${media.mobileDevice`
        width: 30%;
        justify-content: flex-end;
    `}
`;

export const LineSeparator = styled.hr`
    display: none;
    ${media.mobileDevice`
    border: 0;
    border-top: 2px solid #e8e8e8;
    box-sizing: content-box;
    height: 0;
    overflow: visible;
    display: flex;
    `}
`;
